import { getPagePath, trans } from '@spotahome/soyuz/client';

import HeartLockIcon from '../icons/HeartLockIcon';

import Dropdown from '../Dropdown';

import DropdownItem from '../DropdownItem';

import { DSIcon } from '../../../base';

import DropdownSeparator from '../DropdownSeparator/DropdownSeparator';

import styles from './HeaderSupportCenterRedesign.module.scss';

const HeaderSupportCenterRedesign = () => {
  return (
    <Dropdown
      title={
        <>
          <DSIcon name="help_circle" /> <div>{trans('help.title')}</div>
        </>
      }
      position="right"
      color="light"
      itemsColor="light-redesign"
      textTransform="capitalize"
      disableHover
      roundedBorders
      className="menu-white-redesign"
      arrowIcon
    >
      <DropdownItem inline>
        <a href={getPagePath('support')}>
          <div className="dropdown-item__text">
            <DSIcon name="support_agent" className="dropdown-item__icon" />
            {trans('menu.support-center.contact-us')}
          </div>
        </a>
      </DropdownItem>

      <DropdownItem inline>
        <a href={getPagePath('externals.help-center')}>
          <div className="dropdown-item__text">
            <DSIcon name="map" className="dropdown-item__icon" />
            {trans('menu.support-center.help-guide')}
          </div>
        </a>
      </DropdownItem>

      <DropdownSeparator />

      <DropdownItem>
        <div className={styles['header-support-center__guarantees']}>
          <HeartLockIcon
            className={styles['header-support-center__guarantees__icon']}
            size={32}
          />
          <div>
            <p className={styles['header-support-center__guarantees__title']}>
              {trans('menu.support-center.guarantees.title')}
            </p>
            <p
              className={
                styles['header-support-center__guarantees__description']
              }
            >
              {trans('menu.support-center.guarantees.description')}
            </p>
          </div>
        </div>
      </DropdownItem>
    </Dropdown>
  );
};

export default HeaderSupportCenterRedesign;
